export default "__VITE_ASSET__8A1ph6Ud__"